

































import {Component, Prop, Vue} from 'vue-property-decorator'
import {ID, Resp} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import * as Helper from '@/helpers'

@Component
export default class ModalAlertCargaReturned extends Vue {

  list: Carga[] = []

  get collection() {
    return Helper.collect(Carga, this.list)
  }

  close() {
    this.$modal.close('alertCargaReturned')
  }

  async openEvent(ids: ID[]) {
    const promise = ids.slice(0, 10).map((id) => new Carga().getCargaSimples(id))

    const fetch = async () => {
      const responses = await Promise.all(promise)
      this.list = responses.map((resp: Resp<Carga>) => resp.data)
    }

    await this.$await.run(fetch, 'alertCargaReturned')

    this.$emit('open')
  }

  closeEvent() {
    this.$emit('close')
  }
}
